module.exports = __webpack_public_path__ + "assets/img/vtuber-ads7.3be7b1e6.png";